import axios, { AxiosResponse } from 'axios';
import Examiners from '../../../models/examiners.types';
import {
  CardLimits,
  ExaminingTeamMembers,
} from '../../../pages/Sessions/SessionsParametersDialog/SessionsParametersDialogContent/SessionsParametersDialogContent.types';
import EnvWindow from '../../../utils/env';
import { ValidationResult } from '../../validation/validation.service';

export async function UnassignDomesticCoordinatorKk(cordinatorId: string): Promise<AxiosResponse<{ id: string }>> {
  return await axios.put(`${EnvWindow.REACT_APP_EXAMS__EXAMINING_TEAM_API_URL}/UnassignDomesticCoordinator`, {
    domesticCoordinatorId: cordinatorId,
  });
}

export async function AssignDomesticCoordinatorKk(
  cordinatorId: string,
  examinerId: string,
): Promise<AxiosResponse<{ id: string; verificationResult: ValidationResult }>> {
  return await axios.put(`${EnvWindow.REACT_APP_EXAMS__EXAMINING_TEAM_API_URL}/AssignDomesticCoordinator`, {
    domesticCoordinatorId: cordinatorId,
    examinerId: examinerId,
  });
}

export async function UnassignExaminingTeamMember(examiningTeamMemberId: string) {
  const response = await axios.delete(
    `${EnvWindow.REACT_APP_EXAMS_API_URL}/ExaminingTeamMember/${examiningTeamMemberId}`,
  );

  return response;
}

export async function AssignExaminingTeamMemberAPI(
  examiningTeamId: string,
  examiners: Examiners[],
): Promise<AxiosResponse> {
  const response = await axios.post(`${EnvWindow.REACT_APP_EXAMS_API_URL}/ExaminingTeamMember/Bulk`, {
    examiningTeamId: examiningTeamId,
    examiners: examiners,
  });

  return response;
}

export async function assignDomesticCoordinator(
  domesticCoordinatorId: string,
  examinerId: string,
): Promise<AxiosResponse> {
  return await axios.put(`${EnvWindow.REACT_APP_EXAMS__EXAMINING_TEAM_API_URL}/AssignDomesticCoordinator`, {
    domesticCoordinatorId: domesticCoordinatorId,
    examinerId: examinerId,
  });
}

export async function assignAssessmentsGroupMember(
  sampleAssessmentGroupId: string,
  examiners: Examiners[],
): Promise<AxiosResponse> {
  return await axios.post(`${EnvWindow.REACT_APP_EXAMS_API_URL}/SampleAssessmentGroupMember/Bulk`, {
    sampleAssessmentGroupId: sampleAssessmentGroupId,
    examiners: examiners,
  });
}

export async function getCardLimitsByExaminingTeamId(examiningTeamId: string): Promise<{
  defaultCardLimit: CardLimits;
  examiningTeamMembers: ExaminingTeamMembers[];
}> {
  const response = await axios.get(`${EnvWindow.REACT_APP_EXAMS_API_URL}/CardLimit/ExaminingTeam/${examiningTeamId}`);
  return response.data;
}

export async function addExamTaskGroupCoordinator(taskGroupId: string): Promise<AxiosResponse<{ id: string }>> {
  return await axios.post(`${EnvWindow.REACT_APP_EXAMS__EXAM_TASK_GROUP_COORINDATOR_API_URL}`, {
    examTaskGroupId: taskGroupId,
  });
}

export async function assignExamTaskGroupCoordinator(
  coordinatorId: string,
  passedExaminerId: string,
  examinerNumber: string,
) {
  return await axios.patch(
    `${EnvWindow.REACT_APP_EXAMS__EXAM_TASK_GROUP_COORINDATOR_API_URL}/${coordinatorId}/Examiner/${passedExaminerId}/ExaminerNumber/${examinerNumber}`,
  );
}

export async function addExaminingTeamChairman(
  examTaskGroupCoordinatorId: string,
): Promise<AxiosResponse<{ id: string }>> {
  return await axios.post(`${EnvWindow.REACT_APP_EXAMS_API_URL}/ExaminingTeamChairman`, {
    examTaskGroupCoordinatorId: examTaskGroupCoordinatorId,
  });
}

export async function unassignExaminingTeamChairman(examinerTeamChairmanId: string) {
  return await axios.patch(`${EnvWindow.REACT_APP_EXAMS_API_URL}/ExaminingTeamChairman/${examinerTeamChairmanId}`);
}

export async function deleteExaminingTeamChairman(examiningTeamChairmanId: string) {
  return await axios.delete(`${EnvWindow.REACT_APP_EXAMS_API_URL}/ExaminingTeamChairman/${examiningTeamChairmanId}`);
}

export async function unassignExamTaskGroupCoordinator(
  examTaskGroupCoordinatorId: string,
): Promise<AxiosResponse<{ id: string }>> {
  return await axios.patch(
    `${EnvWindow.REACT_APP_EXAMS__EXAM_TASK_GROUP_COORINDATOR_API_URL}/${examTaskGroupCoordinatorId}`,
  );
}

export async function deleteExamTaskGroupCoordinator(taskGroupId: string) {
  await axios.delete(`${EnvWindow.REACT_APP_EXAMS__EXAM_TASK_GROUP_COORINDATOR_API_URL}/${taskGroupId}`);
}

export async function deleteSampleAssessmentGroup(sampleAssessmentGroupId: string): Promise<AxiosResponse<boolean>> {
  return await axios.delete(`${EnvWindow.REACT_APP_EXAMS__SAMPLE_ASSESSMENT_GROUP_API_URL}/${sampleAssessmentGroupId}`);
}

export async function assignExaminingTeamChairman(
  examiningTeamChairmanId: string,
  examinerId: string,
  examinerNumber: string,
) {
  return await axios.patch(
    `${EnvWindow.REACT_APP_EXAMS_API_URL}/ExaminingTeamChairman/${examiningTeamChairmanId}/Examiner/${examinerId}/ExaminerNumber/${examinerNumber}`,
  );
}

export async function isExaminerBlockedInSession(): Promise<boolean> {
  const response = await axios.get(`${EnvWindow.REACT_APP_EXAMS__EXAMINING_TEAM_API_URL}/examiner/blocked`);
  return response.data;
}

export async function addExamTaskGroupCoordinatorToSampleAssessmentGroupChairman(
  sampleAssessmentGroupId: string,
  sampleAssessmentGroupChairmanExaminerId: string,
): Promise<AxiosResponse<{ sampleAssessmenGroupChairmanId: { id: string; verificationResult: ValidationResult } }>> {
  const response = await axios.patch(
    `${EnvWindow.REACT_APP_EXAMS_API_URL}/SampleAssessmentGroupChairman/${sampleAssessmentGroupId}/Examiner/${sampleAssessmentGroupChairmanExaminerId}`,
  );
  return response;
}
